import { render, staticRenderFns } from "./CrearProcedure.vue?vue&type=template&id=76ba633c&scoped=true"
import script from "./CrearProcedure.vue?vue&type=script&lang=js"
export * from "./CrearProcedure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ba633c",
  null
  
)

export default component.exports